// extracted by mini-css-extract-plugin
export default {"upperShieldRoot":"upperShieldRoot___bkcyD","kozel":"kozel___WxiZv","s":"s___WaJVu","m":"m___wQUnL","l":"l___T1amj","upperShieldImg":"upperShieldImg___guxJh"};